import React from "react"
import { Navigate, useLocation } from "react-router-dom"

import { FEATURES_TYPE } from "@constants"
import { DS_REPRICING_ROUTES } from "@constants/routes"
import AppLayout from "Layout"
import DsRepricingStrategiesPage from "Pages/DsRepricing/Page"
import DsRepricingSetupPage      from "Pages/DsRepricing/Setup"
import DsRepricingActivityPage   from "Pages/DsRepricing/Activity"
import DsRepricingSchedulePage   from "Pages/DsRepricing/Schedule"

/** Bounce to /strategies keeping `?rule=<id>` so the deep link still opens
 *  the strategy the overlap modal pointed at. */
function LegacyConfigurationRedirect() {
	const { search } = useLocation()
	return <Navigate to={{ pathname: DS_REPRICING_ROUTES.STRATEGIES_PATH, search }} replace/>
}

export const DsRepricingRoutes = userData => {
	if (!userData?.featuresV2?.ds_repricing) return []

	return [{
		id: FEATURES_TYPE.DS_REPRICING,
		path: DS_REPRICING_ROUTES.PATH,
		title: DS_REPRICING_ROUTES.TITLE,
		icon: 'arrow-trend-up',
		element: <AppLayout/>,
		children: [
			{
				index: true,
				element: <Navigate to={DS_REPRICING_ROUTES.STRATEGIES_PATH} replace/>,
			},
			{
				path: DS_REPRICING_ROUTES.STRATEGIES_PATH,
				title: DS_REPRICING_ROUTES.STRATEGIES_TITLE,
				element: <DsRepricingStrategiesPage/>,
			},
			{
				path: DS_REPRICING_ROUTES.SETUP_PATH,
				title: DS_REPRICING_ROUTES.SETUP_TITLE,
				element: <DsRepricingSetupPage/>,
			},
			{
				path: DS_REPRICING_ROUTES.ACTIVITY_PATH,
				title: DS_REPRICING_ROUTES.ACTIVITY_TITLE,
				element: <DsRepricingActivityPage/>,
			},
			{
				path: DS_REPRICING_ROUTES.SCHEDULE_PATH,
				title: DS_REPRICING_ROUTES.SCHEDULE_TITLE,
				element: <DsRepricingSchedulePage/>,
			},
			// Legacy alias: bookmarks pointing at /blocked land here
			// and get bounced to /activity with the blocked filter
			// pre-applied. Hidden from the menu.
			{
				path: DS_REPRICING_ROUTES.BLOCKED_PATH,
				element: <Navigate to={`${DS_REPRICING_ROUTES.ACTIVITY_PATH}?event_type=blocked_by_limit&only_pending=1`} replace/>,
				noMenu: true,
			},
			// Legacy alias: bookmarks pointing at /configuration land here
			// and get bounced to /strategies. Hidden from the menu.
			//
			// The query string has to survive the bounce: the overlap modal
			// opens the conflicting strategy as `…/configuration?rule=<id>`,
			// and a `Navigate` with a plain string destination drops the
			// search, landing the operator on the list with no drawer — right
			// after a 409, which is exactly when they need to reach the other
			// strategy (CU-869f043c1 QA, defect 2).
			{
				path: DS_REPRICING_ROUTES.CONFIGURATION_PATH,
				element: <LegacyConfigurationRedirect/>,
				noMenu: true,
			},
		]
	}]
}
